import styled, { css } from 'styled-components';

interface FocusedProps {
  $focused?: boolean;
  $variant?: 'classic' | 'modern';
  color?: string;
}

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledStripeElement = styled.div<FocusedProps>`
  width: 100%;
  box-sizing: border-box;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  > .StripeElement {
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
  }

  ${({ $variant }) =>
    $variant === 'modern'
      ? css`
          padding: 0;
          border: none;
          border-radius: 0;
        `
      : css`
          height: 48px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          border: 1.5px solid #D9DDE3;
          border-radius: 10px;
          background: #fff;

          &:hover {
            border-color: #b0b5bd;
          }
        `}

  ${({ $focused, $variant, color }) =>
    $focused &&
    $variant !== 'modern' &&
    css`
      border-color: ${color ?? '#00D95F'};
      box-shadow: 0 0 0 3px ${(color ?? '#00D95F') + '1A'};
    `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
